import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { ReactComponent as DragAndDropIcon } from 'assets/img/drag-and-drop-icon.svg'
import Input from 'components/common/Form/Input'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import messages from './translate'

function DraggableColumnCard({
  intl: { formatMessage },
  id,
  index,
  moveCard,
  submitting,
  onChangeColumnTitle,
  onRemoveColumn,
}) {
  const ref = useRef(null)
  const [, drop] = useDrop({
    accept: 'card',
    hover(item, monitor) {
      if (!ref.current) {
        return
      }

      const dragIndex = item.index
      const hoverIndex = index

      if (dragIndex === hoverIndex) {
        return
      }

      const hoverBoundingRect = ref.current.getBoundingClientRect()
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }

      moveCard(dragIndex, hoverIndex)
      // eslint-disable-next-line no-param-reassign
      item.index = hoverIndex
    },
  })

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'card', id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const opacity = isDragging ? 0 : 1

  drag(drop(ref))

  return (
    <div className="table-column-field" ref={ref} style={{ opacity }}>
      <DragAndDropIcon />
      <Field
        name={`columns[${index}].title`}
        type="text"
        label={`${formatMessage(messages.column)} ${index + 1}`}
        component={Input}
        disabled={submitting}
        validate={getValidator(VALIDATOR_IS_EMPTY)}
        parse={value => {
          onChangeColumnTitle(value, id)

          return value
        }}
      />
      <div
        className="modal-box-x-button"
        onClick={() => {
          onRemoveColumn(index)
        }}
      />
    </div>
  )
}

DraggableColumnCard.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  moveCard: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onChangeColumnTitle: PropTypes.func.isRequired,
  onRemoveColumn: PropTypes.func.isRequired,
}

export default injectIntl(DraggableColumnCard)
